import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import { fetchSyncLogs } from '../../AdminActions';
import DateRenderer from '../../../../components/table-cells/DateRenderer';


class SyncLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organization: null,
      showModal: false,
      loaded: false,
      total: 0,
    };
    this.close = this.close.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.getRows = this.getRows.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const currentId = this.props.organization ? this.props.organization._id : null;
    const nextId = nextProps.organization ? nextProps.organization._id : null;
    if (nextId !== currentId && nextId) {
      this.setState({
        showModal: true,
        organization: nextProps.organization,
        loaded: false,
        total: 0,
      });
    } else if (!nextId) {
      this.setState({ showModal: false });
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    const createDatasource = () => ({
      // called by the grid when more rows are required
      getRows: this.getRows,
    });
    const myDatasource = createDatasource();
    params.api.setServerSideDatasource(myDatasource);
  }

  getRows(params) {
    const { organization } = this.state;
    const { request } = params;

    const query = {
      startRow: request.startRow,
      endRow: request.endRow,
    };
    const p = this.props.dispatch(fetchSyncLogs(organization._id, query));
    p.then(
      ({ docs, total }) => {
        this.setState({ loaded: true, total });
        params.success({ rowData: docs });
        this.gridApi.resetRowHeights();
      },
      (errors) => {
        params.fail(errors);
      },
    );
    return p;
  }

  close() {
    this.props.onClose();
  }

  renderContent() {
    const columnDefs = [
      {
        headerName: 'Date',
        colId: 'DATE',
        width: 120,
        field: 'date',
        cellRenderer: DateRenderer,
      },
      {
        headerName: 'Task',
        colId: 'TASK',
        width: 150,
        field: 'task',
      },
      {
        headerName: 'Message',
        colId: 'MESSAGE',
        width: 280,
        field: 'message',
        autoHeight: true,
        cellClass: 'cell-wrap-text',
      },
    ];

    const tableHeight = 400;

    return (
      <div>
        <div key={this.state.organization._id} className="ag-theme-alpine" style={{ width: '100%', height: tableHeight }}>
          <AgGridReact
            reactNext
            enableColResize
            suppressColumnVirtualisation
            columnDefs={columnDefs}
            getRowId={(params) => params.data._id}
            onGridReady={this.onGridReady}
            onFirstDataRendered={this.onFirstDataRendered}
            deltaRowDataMode
            rowModelType="serverSide"
            defaultColDef={{
              resizable: true,
              filter: false,
              sortable: false,
              suppressMenu: true,
            }}
            pagination
            paginationAutoPageSize
          />
        </div>
      </div>
    );
  }

  render() {
    const {
      organization,
      loaded, total,
    } = this.state;
    if (!organization) {
      return null;
    }
    const hasZeroResults = loaded && total === 0;

    return (
      <Modal show={this.state.showModal} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>{organization.display_name} Sync Error Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {!hasZeroResults && this.renderContent()}
            {hasZeroResults && <div className="alert alert-warning">No logs available yet.</div>}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="link" onClick={this.close}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SyncLog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }),
  onClose: PropTypes.func,
};
SyncLog.defaultProps = {
  organization: null,
  onClose: () => {},
};
function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(SyncLog);
